/**
 * antd 5 主题配置
 *
 * antd 5 起样式改为 CSS-in-JS，less 变量不再导出，原 src/theme.less 里的变量覆盖
 * 必须改用 Design Token 才能保持同样的视觉效果。此处逐条对应旧 theme.less：
 *
 *   @primary-color                -> token.colorPrimary
 *   @link-color                   -> token.colorLink
 *   @font-size-base               -> token.fontSize
 *   @border-radius-base           -> token.borderRadius
 *   @input-height-base            -> token.controlHeight
 *   @btn-height-base              -> token.controlHeight
 *   @input-height-lg / -sm        -> token.controlHeightLG / controlHeightSM
 *   @table-padding-vertical       -> components.Table.cellPaddingBlock
 *   @table-padding-horizontal     -> components.Table.cellPaddingInline
 *   @menu-item-height             -> components.Menu.itemHeight
 *   @menu-inline-toplevel-item-height -> components.Menu.itemHeight
 */
export const antdTheme = {
    token: {
        colorPrimary: '#2F54EB',
        colorLink: '#2F54EB',
        fontSize: 16,
        borderRadius: 2,
        controlHeight: 28,
        controlHeightLG: 40,
        controlHeightSM: 24,
    },
    components: {
        Table: {
            cellPaddingBlock: 8,
            cellPaddingInline: 8,
        },
        Menu: {
            itemHeight: 30,
        },
    },
};

export default antdTheme;
